import { render } from "./ActionsList.vue?vue&type=template&id=8bc847ba"
import script from "./ActionsList.vue?vue&type=script&lang=js"
export * from "./ActionsList.vue?vue&type=script&lang=js"

import "./ActionsList.vue?vue&type=style&index=0&id=8bc847ba&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__